import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Building2 } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { api, track } from "@/lib/api";
import useSeo from "@/lib/useSeo";

export default function Projects() {
  const [projects, setProjects] = useState([]);
  useSeo({ title: "Recent Projects | Emerald Crown Property Investments Nottinghamshire", description: "Recent renovation projects from Emerald Crown Property Investments — before, during and after transformations of tired properties across Nottinghamshire.", path: "/projects" });

  useEffect(() => {
    track("page_view", { page: "projects" });
    api.get("/projects").then(({ data }) => setProjects(data)).catch(() => {});
  }, []);

  return (
    <div className="pt-20">
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-16 md:pt-24">
        <span className="eyebrow">Recent projects</span>
        <h1 className="mt-4 text-4xl sm:text-5xl font-serif font-semibold text-slate-900 leading-tight max-w-3xl">Recent renovation projects across Nottinghamshire</h1>
        <p className="mt-6 text-lg text-slate-600 max-w-2xl leading-relaxed">A closer look at how we approach tired and dated properties — the starting condition, the work involved, the problems we solved, and the outcome.</p>
      </section>

      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-24">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-7">
          {projects.map((p, i) => (
            <Reveal key={p.slug} delay={i * 90}>
              <Link to={`/projects/${p.slug}`} data-testid={`project-card-${p.slug}`} className="group block rounded-2xl overflow-hidden border border-slate-200/80 bg-white hover:shadow-xl transition-all duration-300 h-full">
                <div className="relative h-60 overflow-hidden bg-slate-100">
                  {p.hero_img && <img src={p.hero_img} alt={p.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />}
                  <span className="absolute top-3 left-3 text-[11px] font-mono uppercase tracking-wide px-2.5 py-1 rounded-full bg-emerald-950/85 text-brass backdrop-blur">{p.status}</span>
                </div>
                <div className="p-6">
                  <div className="flex items-center gap-1.5 text-xs text-slate-500"><Building2 className="w-3.5 h-3.5" />{p.location} · {p.type}</div>
                  <h3 className="mt-2 text-xl font-serif text-slate-900">{p.name}</h3>
                  <p className="mt-2 text-sm text-slate-600 leading-relaxed">{p.summary}</p>
                  <span className="mt-4 inline-flex items-center gap-1.5 text-sm font-medium text-emerald-800 group-hover:gap-2.5 transition-all">View case study <ArrowRight className="w-4 h-4" /></span>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </section>
    </div>
  );
}
